import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { toRoute } from "../../i18n";
import styles from './sitemap.module.scss';

export default function Sitemap() {

  const { t } = useTranslation(['translation', 'sitemap'])
  const { pathname } = useLocation()

  return (
    <>
      <Helmet>
        <title>{t("sitemap:title")}</title>
        <meta name="description" content={t("sitemap:metaDescription")} />
        <meta name="keywords" content={t("sitemap:metaKeyWord")} />
      </Helmet>

      <div className={styles.sitemap}>
        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Silverman Sitemap')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Silverman Profile')}</h6>
              <Link to={toRoute('/about')}>{t('sitemap:about us')}</Link>
              <Link to={toRoute('/contact')}>{t('sitemap:contact us')}</Link>
              <Link to={toRoute('/career')}>{t('sitemap:join us')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Property Management')}</h6>
              <Link to={toRoute('/about')}>{t('sitemap:Manage multiple assets')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Tenant management assistant')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Pay common fee online')}</Link>
              <Link to={toRoute('/about')}>{t('sitemap:Common fee discount')}</Link>
              <Link to={toRoute('/')}>{t('sitemap:Property for sale / rent / sale-buyback')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Pricing Package')}</h6>
              <Link to={toRoute('/price-and-package')}>{t('sitemap:Day-to-Day operation and Management Features Package')}</Link>
              <Link to={toRoute('/price-and-package')}>{t('sitemap:Accounting and Financial Features Package')}</Link>
              <Link to={toRoute('/price-and-package/visitor-control')}>{t('sitemap:Visitor Management System and Parking Management Features Package')}</Link>
              <Link to={toRoute('/price-and-package/foqus-package')}>{t('sitemap:E-AGM & E-Vote Package')}</Link>
              <Link to={toRoute('/price-and-package/white-label')}>{t('sitemap:White Label Package')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Using of the Website')}</h6>
              <Link to={toRoute('/privacy')}>{t('sitemap:Terms and Conditions')}</Link>
              <Link to={toRoute('/privacy')}>{t('sitemap:Privacy Policy')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Follow Us')}</h6>
              <a href="https://www.facebook.com/SilvermanApp/" target="_blank" rel="noopener noreferrer">{t('sitemap:Silverman on Facebook')}</a>
              <a href="https://line.me/ti/p/%40silvermanapp" target="_blank" rel="noopener noreferrer">{t('sitemap:Silverman on Line@')}</a>
              <a href="https://www.youtube.com/channel/UC8FZEnXfjUEYkrOeY_63N3w" target="_blank" rel="noopener noreferrer">{t('sitemap:Silverman on Youtube Channel')}</a>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Silverman Application')}</h6>
              <a href="https://apps.apple.com/th/app/silverman/id1436707310" target="_blank" rel="noopener noreferrer">{t('sitemap:Silverman Application iOS')}</a>
              <a href="https://play.google.com/store/apps/details?id=com.port80.silverman&hl=en&gl=US" target="_blank" rel="noopener noreferrer">{t('sitemap:Silverman Application Android')}</a>
              <a href="https://apps.apple.com/th/app/silverman/id1436707310" target="_blank" rel="noopener noreferrer">{t('sitemap:Silverman Application for Niti iOS')}</a>
              <a href="https://play.google.com/store/apps/details?id=com.port80.silverman&hl=en&gl=US" target="_blank" rel="noopener noreferrer">{t('sitemap:Silverman Application for Niti Android')}</a>
            </div>
          </div>
        </div>

        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Silverman Application')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Accounting Software for Juristic')}</h6>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Condominium Accounting Program[1]')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Condominium Accounting Program[2]')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Housing Estate Accounting Program')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Condominium Juristic Person Accounting Program')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Housing Estate Juristic Person Accounting Program')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Cloud Accounting Software')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Juristic Person Accounting Program[2]')}</h6>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Condominium Management Program')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Condominium Juristic Person Program[1]')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Condominium Juristic Person Program[2]')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Housing Estate Management Program')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Program for Real Estate')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Program for Property Management')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Program for Asset Management')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:App for juristic person')}</h6>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Application for Juristic Person')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:App for Condominium')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:App for Village')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:App for Housing Estate')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Application for Condominium')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Application for Village')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:App for Residents')}</Link>
            </div>
          </div>
        </div>


        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Silverman Management')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Management for Juristic System')}</h6>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Juristic Person management System[1]')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Condominium Juristic Person Program[3]')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Condominium Management System[1]')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Condominium Management System[2]')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Housing Estate Juristic Person Management System')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Juristic Person management System[2]')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Housing Estate Juristic Person Management Work')}</h6>
              <Link to={toRoute('/career')}>{t('sitemap:Juristic Person Establishment work')}</Link>
              <Link to={toRoute('/career')}>{t('sitemap:Juristic Person Administrative Work')}</Link>
              <Link to={toRoute('/career')}>{t('sitemap:Find "Juristic Person" work')}</Link>
              <Link to={toRoute('/career')}>{t('sitemap:Find "Juristic Person Management" Work')}</Link>
              <Link to={toRoute('/career')}>{t('sitemap:Find "Juristic Person Administrative" Work')}</Link>
              <Link to={toRoute('/career')}>{t('sitemap:Find "Juristic Person Manager" Work')}</Link>
            </div>
          </div>
        </div>


        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Silverman Features')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Accounting and Finance')}</h6>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Financial Statements of Jurisric Person[1]')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Balance sheet of Jurisric Person')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Income - Expense statement of Jurisric Person')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Financial Statements of Jurisric Person[2]')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:General Ledger of Jurisric Person')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Fines, Penalties and Surcharges Calcualtion')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Income Collection work')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Invoice')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Receive')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Warning letter')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Debt-free Certification[1]')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Debt-free Certification[2]')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:Utility Bills')}</Link>
              <Link to={toRoute('/for-juristic-accounting?type=online')}>{t('sitemap:AI System for Checking Silp')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Juristic Person Management')}</h6>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Juristic Person Committee')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Condominium Juristic Person Committee')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Housing Estate Juristic Person Committee')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Project Detail')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Rules & Regulations')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Register of Co-owners, Residents, Tenants')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Contract Management Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Parcels Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Parcels Management Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Fix Request Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Complaint Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Survey Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:News & Announcement Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Common Areas Booking Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Common Areas Management Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Procurement Work')}</Link>
              <Link to={toRoute('/for-juristic-management?type=property')}>{t('sitemap:Contact Management Work')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Application for Residents')}</h6>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Online Bill Payment')} </Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Parcels Notification')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Fix request')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Complaint')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Answer the Survey')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Receive News & Announcement')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Booking for Common Areas')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Contact with Juristic Person')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Request a Debt-free Certification')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Emergency Contact')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Covid-19 Update')}</Link>
              <Link to={toRoute('/for-resident')}>{t('sitemap:Visitors Management')}</Link>
            </div>
          </div>
        </div>


        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Silverman FoQus')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:e-meeting system')}</h6>
              <Link to={toRoute('/foQus')}>{t('sitemap:meeting e-meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:meeting system e-meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:system for meenting and e-meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:online meeting system')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:electronic meeting system')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:meeting for condo')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:e-meeting condo')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:organize a village meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:e-meeting village')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:General Meeting System via Electronic Media')}</h6>
              <Link to={toRoute('/foQus')}>{t('sitemap:Annual General Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Annual General Meeting by E-Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Condominium Annual General Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Housing Estate Annual General Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:General Meeting via Electronic Media')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Condominium General Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Village General Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Meeting Invitation Letter')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:E-Meeting Invitation Letter')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:E-AGM')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:AGM Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:EGM Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Committee Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:BOC Meeting')}</Link>
              <Link to={toRoute('/foQus')}>{t('sitemap:Agenda')}</Link>
            </div>
          </div>
        </div>


        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Silverman Guard')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Visitor Management System[1]')}</h6>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Access Control System[1]')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Useful of Access Control')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:VMS')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Automatic Access Control System')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Opened-Closed Door Automation System')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Opened-Closed Door Automation System via Smartphone')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Access Control System')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Visitor Control System[1]')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Visitor Control System[2]')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Visitor Control System[3]')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Visitor Management System QR Code')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Visitor Management System[2]')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Visitor Management Solution')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:Visitor Management System[3]')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Security Systems and License Plate Recognition (LPR)')}</h6>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:iGate')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:U-pass')}</Link>
              <Link to={toRoute('/silverman-guard')}>{t('sitemap:License Plate Recognition (LPR)')}</Link>
            </div>
          </div>
        </div>


        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Juristic Person & Project that use Silverman')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Type of Real Estate in Thailand')}</h6>
              <Link to={toRoute('/blog')}>{t('sitemap:Condominium[1]')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Condominium[2]')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Village')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Housing Estate')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Townhome')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Townhouse')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Dormitary')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Apartment')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Service Apartment')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Juristic Person according to Project Owner')}</h6>
              <a href="https://www.apthai.com/th" target="_blank" rel="noopener noreferrer">{t('sitemap:AP (Thailand)')}</a>
              <a href="https://www.sansiri.com/thai/" target="_blank" rel="noopener noreferrer">{t('sitemap:Sansiri')}</a>
              <a href="https://www.pruksa.com" target="_blank" rel="noopener noreferrer">{t('sitemap:Pruksa')}</a>
              <a href="https://www.supalai.com" target="_blank" rel="noopener noreferrer">{t('sitemap:Supalai')}</a>
              <a href="https://www.qh.co.th/home" target="_blank" rel="noopener noreferrer">{t('sitemap:Q house')}</a>
              <a href="https://www.lh.co.th/th" target="_blank" rel="noopener noreferrer">{t('sitemap:Land & House')}</a>
              <a href="https://www.pf.co.th/th/home" target="_blank" rel="noopener noreferrer">{t('sitemap:Property Perfect')}</a>
              <a href="https://www.sena.co.th" target="_blank" rel="noopener noreferrer">{t('sitemap:SENA Development')}</a>
              <a href="https://www.prinsiri.com/th" target="_blank" rel="noopener noreferrer">{t('sitemap:SENA Development')}</a>
              <a href="https://www.ananda.co.th/th/home" target="_blank" rel="noopener noreferrer">{t('sitemap:ANANDA Development')}</a>
              <a href="https://www.noblehome.com/th/home" target="_blank" rel="noopener noreferrer">{t('sitemap:NOBLE Development')}</a>
              <a href="https://www.scasset.com/th/" target="_blank" rel="noopener noreferrer">{t('sitemap:SC Asset')}</a>
              <a href="https://www.cmc.co.th" target="_blank" rel="noopener noreferrer">{t('sitemap:Chaoprayamahanakorn')}</a>
              <a href="http://www.cpland.co.th/home" target="_blank" rel="noopener noreferrer">{t('sitemap:C.P. Land')}</a>
              <a href="https://jsp.co.th" target="_blank" rel="noopener noreferrer">{t('sitemap:J.S.P.')}</a>
            </div>
          </div>
        </div>

        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Property Managements that use Silverman')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Property Management Services[1]')}</h6>
              <Link to={toRoute('/juristic-management-company')}>{t('sitemap:Condominium Juristic Person Property Management Company')}</Link>
              <Link to={toRoute('/juristic-management-company')}>{t('sitemap:Housing Estate Juristic Person Property Management Company')}</Link>
              <Link to={toRoute('/juristic-management-company')}>{t('sitemap:Juristic Person Work Property Management Company')}</Link>
              <Link to={toRoute('/juristic-management-company')}>{t('sitemap:Building Property Management')}</Link>
              <Link to={toRoute('/juristic-management-company')}>{t('sitemap:Condominium Work Property Management Company')}</Link>
              <Link to={toRoute('/juristic-management-company')}>{t('sitemap:Property Management Services[2]')}</Link>
              <Link to={toRoute('/juristic-management-company')}>{t('sitemap:Juristic Person Manager')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Juristic Person according to Property management')}</h6>
              <a href="https://www.fpharrison.co.th" target="_blank" rel="noopener noreferrer">บริษัท เฟิร์ส แปซิฟิค ฮาริสัน จำกัด</a>
              <a href="https://vertiplus98.com" target="_blank" rel="noopener noreferrer">บริษัท เวอร์ติพลัส98 จำกัด</a>
              <a href="https://opencorporates.com/companies/th/0103561001202" target="_blank" rel="noopener noreferrer">หจก จีเคเมเนจเม้นท์ (ประเทศไทย)</a>
              <a href="https://data.creden.co/company/general/0105555088344" target="_blank" rel="noopener noreferrer">บริษัท บิลดิ้ง ดีไซน์ 2549 จำกัด</a>
              <a href="https://www.facebook.com/ProactiveManagement.Th/" target="_blank" rel="noopener noreferrer">บริษัท โปรแอ็คทีฟ แมเนจเม้นท์ จำกัด</a>
              <a href="https://bmgroupitviriyah.wordpress.com/bm-group-พ-ศ-2535ฺbfn-kkknsrhgdehพัำพ้ัuylyyyioo/" target="_blank" rel="noopener noreferrer">บริษัท บางกอก เมเนจเม็นท์ เรียลตี้ จำกัด</a>
              <a href="https://www.powercitymanagement.co.th" target="_blank" rel="noopener noreferrer">บริษัท พาวเวอร์ ซิตี้ แมเนจเม้นท์ จำกัด</a>
              <a href="https://pkkproperty.wordpress.com" target="_blank" rel="noopener noreferrer">บริษัท พีเคเค พร็อพเพอร์ตี้ แมเนจเม้นท์ จำกัด</a>
              <a href="https://www.ocean-manage.com/about-us" target="_blank" rel="noopener noreferrer">บริษัท โอเชี่ยน คอมเมอร์เชี่ยล กรุ๊ป จำกัด</a>
              <a href="https://www.facebook.com/IC.Intensive.Property.Management/?_rdr" target="_blank" rel="noopener noreferrer">บริษัท ไอซี อินเทนซีฟ พร็อพเพอร์ตี้ แมเนจเมนท์ จำกัด</a>
            </div>
          </div>
        </div>

        <div className="container-fluid py-4 py-md-5">
          <h2 className="text-h2">{t('sitemap:Resources of Property Management & Manual of Juristic Person Management')}</h2>
          <hr className="w-100" />

          <div className="row">
            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Property Management News&Articles')}</h6>
              {/* <Link to={toRoute('/blog')}>{t('sitemap:Property Management News')}</Link> */}
              <Link to={toRoute('/blog')}>{t('sitemap:Credit-Finance-Investment News')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Ideas for Decorating House-Condominium')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Accounting-Tax')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Technology')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Horoscope for House-Condominium')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Lifestyle')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Manual of Juristic Person Management')}</h6>
              <Link to={toRoute('/blog')}>{t('sitemap:Condominium Juristic Person')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Housine Estate Juristic Person')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:How to increase income for Juristic Person ?')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Strategies for collecting as many common fees as possible.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:How to increase the effectiveness of your common fees.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Strategies for decrease common fees.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Law for Juristic Person, Rules and Regulations')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Manual of Choosing a Property Management Company')}</h6>
              <Link to={toRoute('/blog')}>{t('sitemap:How to choose Property Management.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Considerations for choosing a property management program.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Considerations for choosing a condominium juristic person accounting program.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Considerations for choosing a housing estate condominium juristic person accounting program.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Considerations for choosing a general meeting online system.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Wage rate for general property management company.')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:List of Property Management[1]')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:Calculate Common Fee')}</h6>
              <Link to={toRoute('/blog')}>{t('sitemap:Common Fee')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Condominium Common Fee[1]')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Condominium Common Fee[2]')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Housing estate Common Fee')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Law of Common Fee')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Fine of Common fee')}</Link>
              <Link to={toRoute('/blog')}>{t('sitemap:Increase of Common Fee')}</Link>
            </div>

            <div className="col-12 col-md-3">
              <h6 className="text-box">{t('sitemap:List of Property Management[2]')}</h6>
              <a href="https://www.sansiri.com/thai/" target="_blank" rel="noopener noreferrer">Sansiri</a>
              <a href="https://www.apthai.com/th" target="_blank" rel="noopener noreferrer">AP Thai</a>
              <a href="https://www.pruksa.com" target="_blank" rel="noopener noreferrer">บริษัท พฤกษา เรียลเอสเตท จำกัด (มหาชน)</a>
              <a href="https://www.lh.co.th/th" target="_blank" rel="noopener noreferrer">Land &amp; Houses</a>
              <a href="https://www.qh.co.th/home" target="_blank" rel="noopener noreferrer">Q House</a>
              <a href="https://www.scasset.com/th/" target="_blank" rel="noopener noreferrer">บริษัท เอสซี แอสเสท คอร์ปอเรชั่น จำกัด(มหาชน)</a>
              <a href="https://www.sena.co.th" target="_blank" rel="noopener noreferrer">บริษัท เสนาดีเวลลอปเม้นท์ จํากัด (มหาชน)</a>
              <a href="https://www.supalai.com" target="_blank" rel="noopener noreferrer">บริษัท ศุภาลัย จํากัด (มหาชน)</a>
              <a href="https://www.nirvanadaii.com/th" target="_blank" rel="noopener noreferrer">บริษัท เนอวานา ไดอิ จำกัด (มหาชน)</a>
              <a href="https://jsp.co.th" target="_blank" rel="noopener noreferrer">บริษัท เจ.เอส.พี. พร็อพเพอร์ตี้ จำกัด (มหาชน)</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )

}
